import { ChevronDownIcon, XCircleFillIcon } from "@primer/octicons-react";
import { Box, Button, SelectPanel } from "@primer/react";
import { useEffect, useMemo, useState } from "react";
import { foDotDangKyAnApi } from "../../api/foDotDangKyAnApi";
import { useCommonContext } from "../../contexts/common";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";
import { IFoDotDangKyAn } from "../../models/response/thuc-don/IFoDotDangKyAn";
interface IComboboxDotDangKyAnProps {
  isReadonly?: boolean;
  value?: number;
  onValueChanged: (id: number, data?: any) => void;
  className?: string;
  preText?: string;
  width?: string | number;
  stylingMode?: "outlined" | "filled" | "underlined";
  isShowClearButton?: boolean;
  isShowAll?: boolean;
}
const ComboboxDotDangKyAn = (props: IComboboxDotDangKyAnProps) => {
  const { dm_coso_id } = useCommonSelectedHook();
  const [dotDangKyAn, setDotDangKyAn] = useState<IFoDotDangKyAn[]>([]);

  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState("");

  const { translate } = useCommonContext();
  const dataSource = useMemo(() => {
    if (props.isShowAll) {
      return dotDangKyAn.map((x) => ({ id: x.id, text: x.dot_dang_ky }));
    }
    return dotDangKyAn
      .filter((x) => x.is_active && x.fo_dotdangky_an_status_id === 1)
      .map((x) => ({ id: x.id, text: x.dot_dang_ky }));
  }, [dotDangKyAn]);
  const filteredItems = useMemo(() => {
    return dataSource.filter((item) =>
      item.text.toLowerCase().includes(filter.toLowerCase())
    );
  }, [dataSource, filter]);
  const selected = useMemo(() => {
    return dataSource.find((x) => x.id === props.value);
  }, [dataSource, props.value]);

  useEffect(() => {
    handleGetDotDangKyAnAsync();
  }, [dm_coso_id]);

  const setSelected = (selecteds: any) => {
    if (selecteds) props.onValueChanged(selecteds.id);
  };
  const handleGetDotDangKyAnAsync = async () => {
    const res = await foDotDangKyAnApi.select_all();
    if (res.is_success) {
      setDotDangKyAn(
        res.data.filter((x: any) => x.is_active && x.dm_coso_id === dm_coso_id)
      );
    }
  };
  return (
    <SelectPanel
      renderAnchor={({
        children,
        "aria-labelledby": ariaLabelledBy,
        ...anchorProps
      }) => (
        <Button
          trailingAction={ChevronDownIcon}
          aria-labelledby={` ${ariaLabelledBy}`}
          {...anchorProps}
          disabled={props.isReadonly}
          sx={{
            width: "100%",
          }}
        >
          <p
            style={{
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {children || translate("Chọn đợt đăng ký")}
          </p>
        </Button>
      )}
      title={
        <>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box sx={{ flex: 1 }}>{translate("Chọn đợt đăng ký")}</Box>
            {props.isShowClearButton && (props.value ?? 0) > 0 && (
              <Button
                trailingVisual={XCircleFillIcon}
                variant="invisible"
                sx={{
                  color: "danger.emphasis",
                }}
                onClick={() => {
                  props.onValueChanged(0);
                }}
              >
                Bỏ chọn
              </Button>
            )}
          </Box>
        </>
      }
      placeholderText="Search"
      open={open}
      onOpenChange={setOpen}
      items={filteredItems}
      selected={selected}
      onSelectedChange={setSelected}
      onFilterChange={setFilter}
      showItemDividers={true}
      overlayProps={{ width: "small", height: "medium" }}
    />
  );
};

export default ComboboxDotDangKyAn;
